export default "__VITE_ASSET__77736e9d__"